"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttemptsList = exports.sortAttemptsByStatus = exports.sortAttemptsByLaunchDate = exports.filterOpenInProgressAttempts = exports.attemptStatusOrder = void 0;
/**
 * Catalog of attempts and their index order
 * in_progress attemps should appear first then opened attempts.
 *
 * If attempts with another status needed to be shown just add them in the object
 * with it's order index
 */
exports.attemptStatusOrder = {
    in_progress: 0,
    open: 1,
};
/**
 * filterOpenInProgressAttempts
 *
 * @param {object}   attempt    - Attempt objec
 *
 * Returns attemps with status in_progress and open
 */
var filterOpenInProgressAttempts = function (attempt) {
    return attempt.isInProgress || attempt.isOpen;
};
exports.filterOpenInProgressAttempts = filterOpenInProgressAttempts;
/**
 * sortAttemptsByLaunchDate
 *
 * @param {object}   prevAttempt    - Previous object with attempt data
 * @param {object}   attempt        - Current object with attempt data
 *
 * Returns an array with attempts ordered by startDate
 */
var sortAttemptsByLaunchDate = function (prevAttempt, currentAttempt) {
    return new Date(prevAttempt.assessment.startDate).getTime() -
        new Date(currentAttempt.assessment.startDate).getTime();
};
exports.sortAttemptsByLaunchDate = sortAttemptsByLaunchDate;
/**
 * sortAttemptsByStatus
 *
 * @param {object}   indexOrder     - Object with information of in which
 *                                    the attempts will be ordered
 * @param {object}   prevAttempt    - Previous object with attempt data
 * @param {object}   attempt        - Current object with attempt data
 *
 * Returns an array with attempts ordered by status
 */
var sortAttemptsByStatus = function (indexOrder) {
    return function (prevAttempt, currentAttempt) {
        return indexOrder[prevAttempt.status] - indexOrder[currentAttempt.status];
    };
};
exports.sortAttemptsByStatus = sortAttemptsByStatus;
/**
 * getAttemptsList
 *
 * @param {object}   attempt     - Attempt
 *
 * Returns an array with attempts filtered by status, sorted by date and status
 */
var getAttemptsList = function (attempts, statusOrder) {
    if (statusOrder === void 0) { statusOrder = exports.attemptStatusOrder; }
    return attempts
        .filter(exports.filterOpenInProgressAttempts)
        .sort(exports.sortAttemptsByLaunchDate)
        .reverse() // sortDescending
        .sort((0, exports.sortAttemptsByStatus)(statusOrder));
};
exports.getAttemptsList = getAttemptsList;
